<app-activitati-table
  [activitatiList]="tables$ | async"
  [activitatiListLength]="total$ | async"
  [loadingDataSpinner]="loadingDataSpinner"
  (filterData)="filterSearchData($event)"
  (pageSizeChanged)="changePageSize($event)"
  (pageNumberChanged)="changePageNumber($event)"
  (callbackResult)="getCallBackResult($event)"
></app-activitati-table>
